"use client";

import Header from "@/components/entities/header";
import Brands from "../home/components/brands";
import Dna from "./components/dna";
import Team from "./components/team";
import Ethics from "./components/ethics";
import Founding from "@/views/about/components/founding";

const AboutView = () => {
  return (
    <>
      <Header />
      <Founding />
      <Team />
      <Dna />
      <Ethics />
      <Brands />
    </>
  );
};

export default AboutView;
